module.exports = __webpack_public_path__ + "img/hina kagiyama_sc1.e0fc83d3.png";